enum FarmerRoutes {
  List = '/farmers',
  Add = '/farmers/add',
  Edit = '/farmers/edit/:id',
}

export default FarmerRoutes
